// Auto generated by ControleTool.ModelClassGenerator
import { inject } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { Helpers } from '../services/helpers';
import { SchoolClassViewModel } from './schoolclassview-model';
import { CourseIndexViewModel } from './courseindexview-model';
import { UserViewModel } from './userview-model';
import { StudentStoredAnswersViewModel } from './studentstoredanswersview-model';


export class ExportClassQuestionViewModel {
    selectedClass: SchoolClassViewModel = null;
	selectedCourse: CourseIndexViewModel = null;
	students: UserViewModel[] = null;
	studentStoredAnswers: StudentStoredAnswersViewModel[] = null;
	
	constructor(data: any = null) {
        
		if (data) {
			Helpers.mapProperties(data, this);
        }
        
	}
}